import React from 'react';
import { TaskState } from 'gql/graphql';
import { TaskStateIcon } from './SharedComponents';

interface BorrowerTaskItemProps {
  task: any;
  handlerClickTask: (task: any) => void;
}

export const BorrowerTaskItem: React.FC<BorrowerTaskItemProps> = ({ 
  task, 
  handlerClickTask 
}) => {
  return (
    <div
      className={`task-item task-item-${task.state}`}
      style={{ 
        cursor: task.state === 'BLOCKED' ? 'pointer' : 
                task.key === 'initial_app' ? 'default' : 
                'pointer' 
      }}
      onClick={() => handlerClickTask(task)}
    >
      <TaskStateIcon state={task.state} />
      <span className="task-label">
        {task.text}
        {(task.state === 'BLOCKED' || task.state === TaskState.Incomplete) &&
         !task.loanDoc && (
          <b> | Complete Task<strong>{'->'}</strong></b>
        )}
        {(task.state === TaskState.Approved ||
          task.state === TaskState.Review ||
          task.state === TaskState.RequestError) &&
         task.key !== 'initial_app' && (
          <b> | View Task <strong>{'->'}</strong></b>
        )}
      </span>
    </div>
  );
};